module.exports = __webpack_public_path__ + "assets/img/save-text.832daab5.png";